module.exports = __webpack_public_path__ + "img/pkf.42d3c291.png";